export const BODY_SHAPE_OPTIONS_FEMALE = [
  { id: 'skinny', title: 'Skinny' },
  { id: 'regular', title: 'Regular' },
  { id: 'athletic', title: 'Athletic' },
  { id: 'plus_size', title: 'Plus size' },
] as const;

export const BODY_SHAPE_OPTIONS_MALE = [
  { id: 'slim', title: 'Slim' },
  { id: 'tone', title: 'Tone' },
  { id: 'muscular', title: 'Muscular' },
  { id: 'plus_size', title: 'Plus size' },
] as const;

export type BodyShapeOptionFemaleIdType =
  (typeof BODY_SHAPE_OPTIONS_FEMALE)[number]['id'];
export type BodyShapeOptionMaleIdType =
  (typeof BODY_SHAPE_OPTIONS_MALE)[number]['id'];
